module.exports = __webpack_public_path__ + "RobotoRegular.d4a0813a773486398ba9.ttf";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoRegular.ttf
// module id = ../../../../../src/fonts/RobotoRegular.ttf
// module chunks = 3